"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  ...props
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
  ...props,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  height: size,
  width: size,
  fill: color,
  role: title ? 'img' : undefined,
  "aria-hidden": !title,
  "aria-labelledby": titleId,
  children: [title ? /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    id: titleId,
    children: title
  }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fillRule: "evenodd",
    d: "M11 0c3.06 0 3.892 1.569 3.99 2.345C15.508 2.729 16 3.389 16 5v2.651c.277.188.43.508.485.728a.49.49 0 0 1 .015.121c0 .822-.481 2.049-.536 2.186a.503.503 0 0 1-.343.3c-.014.012-.096.126-.117.39l-.004.124c0 .435-.148.912-.439 1.42a.501.501 0 0 1-.868-.498c.201-.35.307-.668.307-.922 0-.747.309-1.161.601-1.357.144-.392.373-1.104.397-1.567a.328.328 0 0 0-.057-.094C15.165 8.481 15 8.276 15 8V5c0-1.325-.383-1.7-.607-1.855l-.068-.045c-.121-.078-.325-.206-.355-.481a.519.519 0 0 1 .022-.195l-.024-.094C13.826 1.886 13.155 1 11 1 8.558 1 7 3.369 7 5v3a.5.5 0 0 1-.5.5c.024 0 .015.034.002.072.023.466.253 1.179.397 1.57.292.196.601.611.601 1.358 0 .673.663 1.573 1.318 2.114A.5.5 0 0 1 9 14c0 .635-.577 3.24-2.308 3.962L2.22 19.454c-.708.236-.989.805-1.22 1.706V23h12.605a.5.5 0 0 1 0 1H.5a.5.5 0 0 1-.5-.5v-2.402a.49.49 0 0 1 .015-.121c.261-1.044.67-2.065 1.889-2.472l4.438-1.479c1.043-.436 1.531-2.162 1.636-2.817-.714-.656-1.383-1.62-1.469-2.518L6.5 11.5c0-.354-.105-.5-.161-.527-.156-.039-.244-.138-.304-.287l-.106-.284C5.77 9.961 5.5 9.117 5.5 8.5a.49.49 0 0 1 .015-.121c.055-.22.208-.54.485-.728V5c0-2.088 1.902-5 5-5Zm7.5 13c3.033 0 5.5 2.468 5.5 5.5S21.533 24 18.5 24a5.506 5.506 0 0 1-5.5-5.5c0-3.032 2.467-5.5 5.5-5.5Zm0 1a4.505 4.505 0 0 0-4.5 4.5c0 2.481 2.019 4.5 4.5 4.5s4.5-2.019 4.5-4.5-2.019-4.5-4.5-4.5Zm0 2a.5.5 0 0 1 .5.5V18h1.5a.5.5 0 0 1 0 1H19v1.5a.5.5 0 0 1-1 0V19h-1.5a.5.5 0 0 1 0-1H18v-1.5a.5.5 0 0 1 .5-.5Z",
    clipRule: "evenodd"
  })]
});